import { Component, EventEmitter, Output } from '@angular/core';
import { ExplainMainModuleEnum, ExplainModuleEnum } from '../../../core/user/user.model';
import { MainModuleManagerService } from '../../../shared/services/module-manager.service';
import { UserSessionStore } from '../../../shared/services/user-session.store';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe';

interface MenuItem {
  label: string;
  phIconName: string;
  routerLink?: string;
  mainModule?: ExplainMainModuleEnum;
  module?: ExplainModuleEnum;
}

@AutoUnsubscribe
@Component({
  selector: 'ex-menu',
  templateUrl: './ex-menu.component.html',
  styleUrls: ['./ex-menu.component.scss'],
})
export class ExMenuComponent {
  @Output() logout = new EventEmitter<any>();

  displayedMenuItems: MenuItem[] = [];
  menuItems: MenuItem[] = [
    //region *** Territory Intel ***
    {
      label: 'search',
      phIconName: 'magnifying-glass',
      routerLink: '/search',
      mainModule: ExplainMainModuleEnum.TERRITORY_INTEL,
      module: ExplainModuleEnum.TERRITORY_INTEL,
    },
    {
      label: 'folders',
      phIconName: 'folder-simple',
      routerLink: '/folder',
      mainModule: ExplainMainModuleEnum.TERRITORY_INTEL,
      module: ExplainModuleEnum.TERRITORY_INTEL,
    },
    {
      label: 'alerts',
      phIconName: 'bell',
      routerLink: '/alert',
      mainModule: ExplainMainModuleEnum.TERRITORY_INTEL,
      module: ExplainModuleEnum.TERRITORY_INTEL,
    },
    {
      label: 'topics',
      phIconName: 'chat-circle-text',
      routerLink: '/topics',
      mainModule: ExplainMainModuleEnum.TERRITORY_INTEL,
      module: ExplainModuleEnum.TERRITORY_INTEL,
    },
    //endregion

    //region *** Tenders ***
    {
      label: 'market-watch',
      phIconName: 'binoculars',
      routerLink: '/tenders/watch',
      mainModule: ExplainMainModuleEnum.TENDERS,
      module: ExplainModuleEnum.TENDERS,
    },
    {
      label: 'board',
      phIconName: 'target',
      routerLink: '/tenders/board',
      mainModule: ExplainMainModuleEnum.TENDERS,
      module: ExplainModuleEnum.TENDERS,
    },
    {
      label: 'search',
      phIconName: 'magnifying-glass',
      routerLink: '/tenders/search',
      mainModule: ExplainMainModuleEnum.TENDERS,
      module: ExplainModuleEnum.TENDERS,
    },
    {
      label: 'topics',
      phIconName: 'chat-circle-text',
      routerLink: '/tenders/topics',
      mainModule: ExplainMainModuleEnum.TENDERS,
      module: ExplainModuleEnum.TENDERS,
    },
    {
      label: 'responses',
      phIconName: 'pen-nib',
      routerLink: '/tenders/responses',
      mainModule: ExplainMainModuleEnum.TENDERS,
      module: ExplainModuleEnum.RESPONSE,
    },
    {
      label: 'library',
      phIconName: 'books',
      routerLink: '/tenders/library',
      mainModule: ExplainMainModuleEnum.TENDERS,
      module: ExplainModuleEnum.RESPONSE,
    },
    //endregion
  ];
  accountMenuItems: MenuItem[] = [
    {
      label: '',
      phIconName: 'user-circle-gear',
      routerLink: '/settings',
      mainModule: undefined,
      module: undefined,
    },
    {
      label: '',
      phIconName: 'sign-out',
      routerLink: undefined,
      mainModule: undefined,
      module: undefined,
    },
  ];

  constructor(
    private mainModuleManagerService: MainModuleManagerService,
    private sessionStore: UserSessionStore
  ) {
    this.mainModuleManagerService.explainMainModuleChanged.subscribe(() => {
      this.updateDisplayedMenuItems();
    });
  }

  get activeExplainMainModule(): ExplainMainModuleEnum {
    return this.mainModuleManagerService.activeExplainMainModule ?? ExplainMainModuleEnum.TERRITORY_INTEL;
  }

  get alternativeExplainMainModule(): ExplainMainModuleEnum | null {
    return this.mainModuleManagerService.alternativeExplainMainModule;
  }

  private updateDisplayedMenuItems(): void {
    const userModules = this.sessionStore.userSession()?.modules ?? [];
    this.displayedMenuItems = this.menuItems.filter(item => {
      return (
        item.mainModule === undefined ||
        (item.mainModule === this.activeExplainMainModule && item.module && userModules.some(module => module.name === item.module))
      );
    });
  }

  signOut() {
    this.logout.emit();
  }

  onClickAccountMenuItem(item: MenuItem) {
    if (item.phIconName === 'sign-out') {
      this.signOut();
    }
  }
}
